<template>
  <div>
    <div
      v-if="!loaded"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div class="columns">
      <div
        v-if="loaded && selectedState"
        class="column"
      >
        <div class="field has-addons">
          <div
            class="dropdown"
            :class="{'is-active': dropdownRegion}"
            @click="showRegion"
          >
            <div class="dropdown-trigger">
              <button
                class="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
              >
                <span>{{ selectedRegion }}</span>
                <span class="icon is-small">
                  <i
                    class="far fa-angle-down"
                    aria-hidden="true"
                  />
                </span>
              </button>
            </div>
            <div
              v-if="dropdownRegion"
              class="dropdown-menu"
            >
              <div class="dropdown-content">
                <a
                  v-for="region in selectedState.regions"
                  class="dropdown-item"
                  @click="switchRegion(region.regionId)"
                >{{ region.regionId }}</a>
              </div>
            </div>
          </div>
          <div class="control">
            <router-link
              :to="{name: 'Calendar', params: {state: selectedState, selectedRegion: {number: selectedRegion}}}"
              class="button is-dark"
            >
              Go
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ul class="is-list-style list-region">
        <li v-for="region in selectedState.regions">
          <router-link :to="{name: 'Calendar', params: {state: selectedState, selectedRegion: region.regionId}}">
            {{ region.regionId }}
          </router-link>: {{ region.counties }}
        </li>
      </ul>
    </div>
    <div v-if="loaded && !selectedState">
      <p class="text-center">
        Thank you for visiting AHLPoker.com.
      </p>
      <p class="text-center">
        At this time we do not have any venues in your area. However, we are growing rapidly, and will be coming to your area soon.
      </p>
      <p class="text-center">
        If you would like to be notified when a venue becomes available in your area, please enter your e-mail address below. We will contact you as soon as a venue near you opens.
      </p>
      <p class="text-center">
        <strong>See you soon!</strong>
      </p>
      <p class="text-center">
        <label class="label is-size-6-touch"> E-mail Address:</label> <input
          class="input"
          type="email"
          style="width: 220px;"
        > <button
          class="button is-dark"
          type="submit"
        >
          Continue
        </button>
      </p>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'SelectRegion',
    components: {
    },
    props: ['state', 'user', 'token'],
    data () {
      return {
        loaded: false,
        states: '',
        selectedState: '',
        selectedRegion: '',
        dropdownRegion: false,
        dropdownCounty: false
      }
    },
    mounted () {
      this.getByState()
    },
    methods: {
      switchRegion (region) {
        this.selectedRegion = region
      },
      showRegion () {
        this.dropdownRegion = !this.dropdownRegion
      },
      getByState () {
        let url = `general/regions/getbystate/${this.$route.params.state}`
        this.$axios({
          method: 'POST',
          url,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            if (res.data.length > 0) {
              let regions = []
              for (let i = 0; i < res.data.length; i++) {
                regions.push({
                  regionId: res.data[i].regid,
                  name: res.data[i].regid + ": " + res.data[i].name,
                  counties: res.data[i].name
                })
              }
              this.selectedState = {
                name: this.$route.params.state,
                regions
              }
              this.selectedRegion = this.selectedState.regions[0].regionId
            }
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
      }
    }
  }
</script>
